<template>
    <div class="con">
        <div class="cy">
            <div class="swiper">
                <swiper :options="swiperOption" ref="mySwiper" class="list" v-if="list.length>1">
                    <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                        <div class="main">
                            <div class="left">
                                <p class="p1" v-if=" $i18n.locale === 'zh-CN'">{{item.CALLED}}</p>
                                <p class="p2" :class="{'enp2':$i18n.locale === 'en'}">{{item.TEXT2}}</p>
                                <p class="p3" :class="{'enp3':$i18n.locale === 'en'}">{{item.TEXT1}}</p>
                                <p class="p4" :class="{'enp4':$i18n.locale === 'en'}" @click="gotoCy(index)">{{$t('gyl').text1}}</p>
                            </div>
                            <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="">
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="btn prev ">
                    <btn-Component style="padding-top: 0;"></btn-Component>
                </div>
                <div class="btn next ">
                    <btn-Component style="padding-top: 0;"></btn-Component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import btnComponent from '../components/btn2'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {getProductstypeUrl2} from '../util/lang'
    export default {
        name: "gyl",
        data(){
            return{
                swiperOption:{
                    notNextTick: true,
                    slidesPerView: 1,
                    speed:3000,
                    loop: true,
                    autoplay:false,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.cy .btn.prev',
                        nextEl: '.cy .btn.next',
                    }
                },
                list:[],
            }
        },
        components:{btnComponent,swiper,swiperSlide},
        mounted(){
            if( this.$i18n.locale === 'en'){
                this.getPro('47')
            }else{
                this.getPro('42')
            }
        },
        methods:{
            gotoCy(n){
                this.$router.push({path:'/cy',query:{index2:n}})
            },
            getPro(id){
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        this.list=res.data
                        setTimeout(()=>{
                            this.$refs.mySwiper.swiper.init()
                        },100)
                    })
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    height:700px;
    position: relative;
    overflow: hidden;
    .cy{
        width:85%;
        margin-left: 15%;
        .swiper{
            width:100%;
            padding-bottom: 60px;
            .list{
                padding-right: 100px;
            }
            .item{
                display: flex;
                cursor: pointer;
                transition: all 2s;
                .main{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    .left{
                        width:30%;
                        transition: all 600ms;
                        p{
                            padding-left: 20px;
                        }
                        .p1{
                            font-size: 25px;
                            color:#04356F;
                            font-weight: bold;
                            position: relative;
                        }
                        .p1::before{
                            position: absolute;
                            content:'';
                            display: inline-block;
                            width:1px;
                            height:80px;
                            left:0;
                            top:0;
                            background-color: #828282;
                        }
                        .p2{
                            font-size: 40px;
                            color:#444546;
                            text-transform: uppercase;
                            font-weight: bold;
                            margin-top: 10px;
                            font-family: 'black';
                            position: absolute;
                            left:0;
                            top:8%;
                            width:50%;
                        }
                        .p3{
                            width:80%;
                            font-size: 14px;
                            color:#444546;
                            line-height: 30px;
                            margin-top: 160px;
                            height:300px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 10;
                            overflow: hidden;
                        }
                        .enp3{
                            margin-top: 200px;
                        }
                        .p4{
                            color:#444546;
                            font-family: normal;
                            font-weight: lighter;
                            font-size: 14px;
                          position: absolute;
                            top:60%;
                            left:0;
                            cursor: pointer;
                        }
                    }
                    img{
                        width:65%;
                        object-fit: contain;
                        margin-left: -2%;
                        transition: all 2s;
                        height:700px;
                    }
                }
            }
            .swiper-slide-next,.swiper-slide-prev{
                opacity: 0.2;
            }
            .swiper-slide-active{
                opacity: 1;
            }
            .prev{
                width:60px;
                height:60px;
                position: absolute;
                left:15%;
                bottom:15%;
                border-radius: 50%;
                transform: rotate(180deg);
                z-index: 1000;
            }
            .next{
                width:60px;
                height:60px;
                border-radius: 50%;
                position: absolute;
                left:25%;
                bottom:15%;
                z-index: 1000;
            }
        }
    }
    .prev:focus{
        outline: none;
    }
    .next:focus{
        outline: none;
    }
    @media screen and (min-width:2500px){
        height:800px;
    }
    @media screen and (max-width: 1440px){
      height:650px;
        .cy{
            .swiper{
                .item{
                    .main{
                        .left{
                            p:nth-child(2){
                                font-size: 30px;
                            }
                            .enp2{
                                font-size: 30px;
                            }
                            .enp3{
                                height:210px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 7;
                                overflow: hidden;
                                font-size: 14px !important;
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        height:500px;
        margin-top: 300px;
    .cy{
        width:100%;
        margin-left: 0;
        .swiper{
            .swiper-container{
                overflow: visible;
            }
            .list{
                padding-right: 0;
            }
            .item{
                .main{
                    flex-direction: column-reverse;
                    .left{
                        width:100%;
                        .p1{
                            font-size: 20px;
                            margin-top: 20px;
                        }
                       .p2{
                            font-size: 20px;
                            width:90%;
                            top:2%;
                            color:white;
                        }
                        .p3{
                            margin-top: 10px;
                            height:180px;
                            width:90%;
                            margin-left: 0%;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 6;
                            overflow: hidden;
                        }
                        .enp3{
                            height:160px;
                            font-size: 14px !important;
                            -webkit-line-clamp:5;
                        }
                       .p4{
                            top:95%;
                            z-index: 1000;
                        }
                        .enp4{
                            top:100%;
                        }
                    }
                    img{
                        height:180px;
                        width:100%;
                        object-fit: cover;
                        margin-left: 0;
                    }
                }
            }
            .prev{
                bottom:5%;
                left:25%;
            }
            .next{
                bottom:5%;
                left:55%;
            }
        }
    }
    }
}
</style>